<template>
  <q-card flat>
    <q-card-section class="no-padding ">
      <q-banner class="bg-indigo text-white" inline-actions>
        برگشت فروش مربوط به فاکتور {{ saleNum }}
        <template v-slot:action>
          <q-btn icon="close" flat round dense v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section>
      <q-chip v-if="orderInfo.Cs_Name" clickable :label="orderInfo.Cs_Name" square icon="person"
              @click="showCustomerInfo"/>
      <q-space/>
      <q-chip square label="تعداد کالا فاکتور" color="indigo" text-color="white">
        <q-badge class="q-ml-sm"
                 :label="lodash.sumBy(orderItems,item=>parseInt(item.GStore1+item.GStore2+item.GStore3+item.GStore4))"
                 color="red"
                 text-color="white"/>
      </q-chip>
      <q-chip square label="تعداد کالای برگشتی فاکتور" color="indigo" text-color="white">
        <q-badge class="q-ml-sm"
                 :label="lodash.sumBy(orderItems,item=>parseInt(item.Store1) + parseInt(item.Store2) + parseInt(item.Store3) + parseInt(item.Store4))"
                 color="red"
                 text-color="white"/>
      </q-chip>
    </q-card-section>
    <q-card-section>
      <q-table
          :data="orderItems"
          row-key="Table_IDD"
          wrap-cells
          flat
          :hide-header="$q.screen.lt.md"
          :pagination.sync="pagination">
        <template v-slot:header>
          <q-tr class="text-center text-bold">
            <td>
              عنوان کالا
            </td>
            <td>
              مرکزی
            </td>
            <td>
              فروشگاه
            </td>
            <td>
              پل پنجم
            </td>
            <td>
              کارخانه صاف
            </td>
            <td>
              دیجیکالا
            </td>

          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props" :class="props.row.SaleG_Count===0?'bg-blue-grey-2':''" v-if="!$q.screen.lt.md">
            <td class="text-subtitle2">
              <q-badge :label="props.row.Goods_Code" align="top" color="red" text-color="white"/>
              <q-space/>
              {{ props.row.Goods_Name }}
            </td>
            <td class="text-center" style="width: 150px">
              <q-input
                  @change="controlState(props.row)"
                  :disable="props.row.GStor1===0 || props.row.SaleG_Count===0"
                  min="0"
                  v-model="props.row.Store1"
                  :label="`${props.row.GStore1}`"
                  label-color="deep-orange"
                  type="number"
                  error-message="مقدار نامعتیر می باشد"
                  filled/>
            </td>
            <td class="text-center" style="width: 150px">
              <q-input
                  @change="controlState(props.row)"
                  :disable="props.row.GStor2===0 || props.row.SaleG_Count===0 || (![1139,113218, 115187, 6616].includes(orderInfo.Cs_ID) && !$store.state.roles.some(v=>['admin','can_issue_product_from_shop'].includes(v)))"
                  min="0"
                  v-model="props.row.Store2"
                  :label="`${props.row.GStore2}`"
                  label-color="deep-orange"
                  type="number"
                  filled/>
            </td>
            <td class="text-center" style="width: 150px">
              <q-input
                  @change="controlState(props.row)"
                  :disable="props.row.GStor3===0 || props.row.SaleG_Count===0"
                  min="0"
                  v-model="props.row.Store3"
                  :label="`${props.row.GStore3}`"
                  label-color="deep-orange"
                  stack-label
                  type="number"
                  filled>
              </q-input>
            </td>
            <td class="text-center" style="width: 150px">
              <q-input
                  @change="controlState(props.row)"
                  min="0"
                  :disable="props.row.GStor4===0 || props.row.SaleG_Count===0"
                  v-model="props.row.Store4"
                  :label="`${props.row.GStore4}`"
                  label-color="deep-orange"
                  type="number"
                  filled/>
            </td>
            <td class="text-center" style="width: 150px">
              <q-input
                  @change="controlState(props.row)"
                  min="0"
                  :disable="props.row.GStor6===0 || props.row.SaleG_Count===0 && !$store.state.roles.some(v=>['admin'].includes(v))"
                  v-model="props.row.Store6"
                  :label="`${props.row.GStore6}`"
                  label-color="deep-orange"
                  type="number"
                  filled/>
            </td>

          </q-tr>
          <q-tr :props="props" :class="props.row.SaleG_Count===0?'bg-blue-grey-2':''" v-if="$q.screen.lt.md">
            <q-card flat>
              <q-card-section class="no-padding">
                <q-list separator>
                  <q-item clickable v-ripple>
                    <q-item-section>{{ props.row.Goods_Name }}</q-item-section>
                    <q-item-section side>
                      <q-badge :label="props.row.Goods_Code" align="top" color="red" text-color="white"/>
                    </q-item-section>
                  </q-item>

                  <q-item clickable v-ripple active-class="text-orange">
                    <q-item-section>مرکزی</q-item-section>
                    <q-item-section side>
                      <q-input
                          @change="controlState(props.row)"
                          :disable="props.row.GStor1===0 || props.row.SaleG_Count===0"
                          min="0"
                          dir="ltr"
                          v-model="props.row.Store1"
                          :label="`${props.row.GStore1}`"
                          label-color="deep-orange"
                          type="number"
                          error-message="مقدار نامعتیر می باشد"
                          filled/>
                    </q-item-section>
                  </q-item>
                  <q-item clickable v-ripple active-class="text-orange">
                    <q-item-section>فروشگاه</q-item-section>
                    <q-item-section side>
                      <q-input
                          @change="controlState(props.row)"
                          :disable="props.row.GStor2===0 || props.row.SaleG_Count===0 || (![1139,113218, 115187, 6616].includes(orderInfo.Cs_ID) && !$store.state.roles.some(v=>['admin','can_issue_product_from_shop'].includes(v)))"
                          min="0"
                          dir="ltr"
                          v-model="props.row.Store2"
                          :label="`${props.row.GStore2}`"
                          label-color="deep-orange"
                          type="number"
                          filled/>
                    </q-item-section>
                  </q-item>
                  <q-item clickable v-ripple active-class="text-orange">
                    <q-item-section>پل پنجم</q-item-section>
                    <q-item-section side>
                      <q-input
                          @change="controlState(props.row)"
                          :disable="props.row.GStor3===0 || props.row.SaleG_Count===0"
                          min="0"
                          dir="ltr"
                          v-model="props.row.Store3"
                          :label="`${props.row.GStore3}`"
                          label-color="deep-orange"
                          stack-label
                          type="number"
                          filled>
                      </q-input>
                    </q-item-section>
                  </q-item>
                  <q-item clickable v-ripple active-class="text-orange">
                    <q-item-section>مارخانه صاف</q-item-section>
                    <q-item-section side>
                      <q-input
                          @change="controlState(props.row)"
                          min="0"
                          dir="ltr"
                          :disable="props.row.GStor4===0 || props.row.SaleG_Count===0"
                          v-model="props.row.Store4"
                          :label="`${props.row.GStore4}`"
                          label-color="deep-orange"
                          type="number"
                          filled/>
                    </q-item-section>
                  </q-item>
                  <q-item clickable v-ripple active-class="text-orange">
                    <q-item-section>دیجیکالا</q-item-section>
                    <q-item-section side>
                      <q-input
                          @change="controlState(props.row)"
                          min="0"
                          dir="ltr"
                          :disable="props.row.GStor6===0 || props.row.SaleG_Count===0 && !$store.state.roles.some(v=>['admin'].includes(v))"
                          v-model="props.row.Store6"
                          :label="`${props.row.GStore6}`"
                          label-color="deep-orange"
                          type="number"
                          filled/>
                    </q-item-section>
                  </q-item>
                </q-list>
              </q-card-section>
              <q-card-section>
                <q-separator color="indigo" />
              </q-card-section>
            </q-card>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>
    <q-card-actions align="center">
      <q-btn label="ثبت برگشتی"
             type="button"
             v-if="orderItems.length>0"
             @click="issueReturnSaleExi"
             :disable="orderItems.length===0 || inProgress"
             class="bg-indigo-6 text-white" icon="add_shopping_cart"/>
      <q-btn label="انصراف" v-close-popup flat class="q-ml-sm" icon="cancel" color="red"/>
    </q-card-actions>
    <q-dialog v-model="customerProfileDialog">
      <CustomerInfo :selected-customer="selectedCustomer"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import CustomerInfo from "@/components/customers/CustomerInfo";

export default {
  name: "IssueReturnOrder",
  components: {CustomerInfo},
  props: {
    csID: {
      type: Number,
      required: true
    },
    havaNum: {
      type: Number,
      required: true
    },
    saleNum: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      issueVisible: false,
      pagination: {
        rowsPerPage: 50
      },
      inProgress: false,
      selectedCustomer: null,
      customerProfileDialog: false,
      orderInfo: '',
      orderItems: [],
    }
  },
  methods: {
    ...mapActions({
      getOrderItems: 'Orders/getExiStoreItems',
      getCustomerInfo: 'Customers/get_customer_info',
      IssueReturnSale: 'Orders/IssueReturnSale'
    }),
    issueReturnSaleExi() {
      this.inProgress = true;
      this.IssueReturnSale({
        saleNum: this.saleNum,
        havaNum: this.havaNum,
        items: this.orderItems.filter(item => parseInt(item.Store1) + parseInt(item.Store2) + parseInt(item.Store3) + parseInt(item.Store4) + parseInt(item.Store6) > 0)
      }).then((res) => {
        if (res.sale_num !== '-1') {
          this.$q.notify({
            type: 'positive',
            color: 'positive',
            position: 'top',
            message: `سند برگشتی برای فاکتور ${this.saleNum} به شماره ${res.sale_num} صادر شد`
          })
        }
        this.$emit('refresh-data')
        this.inProgress = false;
      }).catch(() => {
        this.inProgress = false;
      })
    },
    controlState(row) {
      if (parseInt(row.Store1) + parseInt(row.Store2) + parseInt(row.Store3) + parseInt(row.Store4) + parseInt(row.Store6) >
          parseInt(row.GStore1) + parseInt(row.GStore2) + parseInt(row.GStore3) + parseInt(row.GStore4) + parseInt(row.GStore6)) {
        row.Store1 = 0
        row.Store2 = 0
        row.Store3 = 0
        row.Store4 = 0
        row.Store6 = 0
        this.$q.notify({
          type: 'negative',
          color: 'negative',
          position: 'top',
          message: 'مقادیر وارد شده بیشتر از تعداد کالا در حواله می باشد'
        })
      }
    },
    showCustomerInfo() {
      this.getCustomerInfo(this.orderInfo.Cs_ID).then((res) => {
        this.selectedCustomer = res.data[0]
        this.customerProfileDialog = true
      })
    }
  },
  created() {
    if (this.havaNum) {
      this.getOrderItems(this.havaNum).then((res) => {
        this.orderItems = res
      })
    }
  }
}
</script>

<style scoped>

</style>